import type { Asset, Session } from '../shared/types';

// Every wallet request belongs to the identity that started it. Reconnecting
// does not make an older fetch current again, even if the hook stays mounted.
export class IdentityResponses {
  private version=0;
  private writerId:string|null=null;
  stamp(){return this.version;}
  current(version:number){return version===this.version;}
  begin(){this.writerId=null;return ++this.version;}
  accept(version:number,session:Session,publish:(session:Session)=>void){
    if(!this.current(version))return false;
    this.writerId=session.id;publish(session);return true;
  }
  matches(session:Session){return this.writerId===session.id;}
}

export async function refreshStreetIdentity(responses:IdentityResponses,actions:{resetBootstrap:()=>void;clearCatalog:()=>void;reconnect:()=>void;session:()=>Promise<Session>;publish:(session:Session)=>void}){
  const version=responses.begin();
  actions.resetBootstrap();actions.clearCatalog();actions.reconnect();
  const player=await actions.session();
  responses.accept(version,player,actions.publish);
}

export async function loadIdentityCatalog(responses:IdentityResponses,version:number,load:()=>Promise<Asset[]>,publish:(assets:Asset[])=>void){
  try{const assets=await load();if(responses.current(version))publish(assets);}catch{/* Catalog failure cannot undo a successful identity change or reconnect. */}
}
